import screenerNavigationRoutes from "./navigationRoutes";
import ScreenerHomePage from "../pages/ScreenerHomePage";
import CompanyDetailsPage from "../pages/CompanyDatilesPage";
// Public routes that don't require authentication
const publicRoutes: Array<{
  path: string;
  element: React.ComponentType;
  name: string;
}> = [
  {
    path: screenerNavigationRoutes.SCREENER_HOME,
    element: ScreenerHomePage,
    name: "Screener Home",
  },
  {
    path: screenerNavigationRoutes.COMPANY_DETAILS_ROUTE,
    element: CompanyDetailsPage,
    name: "Company Details",
  },
];

// Auth routes that require authentication
const authRoutes: Array<{
  path: string;
  element: React.ComponentType;
  name: string;
}> = [
  // Add your auth routes here
];

// Main routes configuration
const routes = [
  {
    type: "auth",
    routes: authRoutes,
  },
  {
    type: "public",
    routes: publicRoutes,
  },
];

export default routes;
